import type { ReactNode } from "react";
import { family } from "../lib/format";

/** The buyer family badge (ARMY, NAVY, DoW …) that reads before a record's title. */
export function Badge({ agency, small }: { agency: string | null | undefined; small?: boolean }) {
  const f = family(agency);
  let label: ReactNode = f.label;
  let length = f.label.length;
  if (/COM$/.test(f.label) && length > 5) {
    label = (
      <>
        {f.label.slice(0, -3)}
        <br />
        COM
      </>
    );
    length = Math.max(length - 3, 3);
  }
  const size = (small ? 32 : 44) * (length <= 4 ? 0.27 : length === 5 ? 0.23 : 0.2);
  return (
    <span className={`badge ${small ? "sm" : ""}`} style={{ background: f.color, fontSize: `${size.toFixed(1)}px`, lineHeight: 1.05 }} aria-hidden="true">
      {label}
    </span>
  );
}

export function Face({ id, text, big }: { id: number | string; text: string; big?: boolean }) {
  const colors = ["#A87B2E", "#3F7D6E", "#5B6FB0", "#9A4F6B", "#6C7A3B", "#3A6EA5", "#8A2A2A", "#55606E"];
  return (
    <span className={`face ${big ? "big" : ""}`} style={{ background: colors[(Number(id) || 0) % colors.length] }}>
      {text}
    </span>
  );
}
